var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.15422 0 0 4.94409 0 11.0312C0 11.2438 0 11.4565 0.0277108 11.7223C0.249398 15.4968 2.13373 19.4574 5.65301 23.5243C8.23012 26.5014 10.7241 28.3886 10.8349 28.4684L11.5277 28.9734L12.2205 28.4684C12.3313 28.3886 14.8253 26.5014 17.4024 23.5243C20.9217 19.4574 22.806 15.4968 23.0277 11.7223C23.0554 11.4565 23.0554 11.2438 23.0554 11.0312C23 4.94409 17.8458 0 11.5 0Z",
    fill: "#0DA047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5618 17H6.43825C6.19283 17 6 16.8072 6 16.5618C6 16.3163 6.19283 16.1235 6.43825 16.1235H16.5618C16.8072 16.1235 17 16.3163 17 16.5618C17 16.8072 16.8072 17 16.5618 17Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9426 6.87649H11.0661C10.8207 6.87649 10.6279 6.68367 10.6279 6.43825C10.6279 6.19283 10.8207 6 11.0661 6H11.9426C12.188 6 12.3809 6.19283 12.3809 6.43825C12.3809 6.68367 12.1793 6.87649 11.9426 6.87649Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5044 7.81434C8.47171 7.81434 6 10.2773 6 13.31C6 13.8972 6.47331 14.3705 7.06056 14.3705H15.9394C16.5267 14.3705 17 13.8972 17 13.31C17 10.2773 14.5371 7.81434 11.5044 7.81434Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallGreen);
export default __webpack_public_path__ + "static/media/small-green.ee1698b9fb9f52dfd8bffcc06ee8d16d.svg";
export { ForwardRef as ReactComponent };